module.exports = __webpack_public_path__ + "static/logo_text-49eb26bc58259a531d5b46b0b0dc3f57.svg";